import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para quien parte de cero y quiere entender cómo empezar sin sentirse perdido.'
}, {
  q: '¿Esto son señales de compra/venta?',
  a: 'No. Acá no te decimos qué hacer con tu plata. Te explicamos una forma de pensar tus decisiones para que las entiendas y las tomes vos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas se acredita la compra recibís el acceso al ebook, los bonos y la comunidad de Discord.'
}, {
  q: '¿Cuánto tiempo tengo acceso al Discord?',
  a: 'Tenés 1 año de acceso desde el momento de la compra.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-ink-950" data-id="element-63" data-mp="no9zm98ebkeu">
      <Reveal data-id="element-64" data-mp="nn8racirlc0t">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-65" data-mp="nmp4oii65zgg">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <div className="mt-8 space-y-3" data-id="element-66" data-mp="ufpuehd1ztzo">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <Reveal key={faq.q} delay={index * 0.05} data-id="element-67" data-mp="fm4en7t8orye" data-mpi={index}>
              <div className="overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-68" data-mp="khjshzr8ynut">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-ink-850" data-id="element-69" data-mp="6qexxc2qklrc">
                  <span className="font-display text-sm font-semibold text-white sm:text-base" data-id="element-70" data-mp="1t53tj4ejlx6">{faq.q}</span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-71" data-mp="3jyi18y2vyh6g" />
                </button>
                <AnimatePresence initial={false} data-id="element-72" data-mp="1uhcsnkox44bo">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} data-id="element-73" data-mp="1pqe98c8muq47">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-gray-400" data-id="element-74" data-mp="2dfgmz905bytf">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}